<lib-form-field-container [kind]="FormContainerKind.Radio">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        @if (isReadOnly) {
            <div class="default-content">
                <ng-template *ngTemplateOutlet="currentItemComponent.label"></ng-template>
            </div>
        }
    </ng-container>

    @if (!isReadOnly) {
        <mat-radio-group
            #radioGroup
            [id]="formFieldID"
            [attr.aria-labelledby]="ariaLabel ? null : formFieldID + '-label'"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
            [formControl]="viewControl"
            (change)="ChangeEvent($event)">
            <div class="d-flex flex-column">
                @for (item of itemQueryList; track item) {
                    <div class="sb-form-field-radio-button">
                        @if (isLoading) {
                            <div class="sb-form-field-radio-button-loading"></div>
                        } @else {
                            <mat-radio-button
                                #radioButton
                                [value]="item.value"
                                [disabled]="item.disabled"
                                [attr.data-sb-qa]="item.qaTag"></mat-radio-button>
                        }

                        <div
                            class="sb-form-field-radio-button-wrapper"
                            [class.cursor-pointer]="!formControl.disabled && !item.disabled && !isLoading"
                            (click)="!isLoading && !item.disabled && SetValue(item.value)">
                            <p [class.sb-form-field-text-skeleton]="isLoading"><ng-template *ngTemplateOutlet="item.label"></ng-template></p>
                            <small
                                #supportingText
                                class="sb-form-field-radio-button-supporting-text"
                                [hidden]="!isLoading && !supportingText.textContent">
                                @if (isLoading) {
                                    <div
                                        #supportingTextContent
                                        hidden>
                                        <ng-container *ngTemplateOutlet="item.supportingText"></ng-container>
                                    </div>
                                    @if (supportingTextContent.textContent) {
                                        <div class="sb-form-field-text-skeleton sb-form-field-text-skeleton-sm"></div>
                                    }
                                } @else {
                                    <ng-container *ngTemplateOutlet="item.supportingText"></ng-container>
                                }
                            </small>
                        </div>
                    </div>
                }
            </div>
        </mat-radio-group>
    }
</lib-form-field-container>
